import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { WebinarLibraryModel } from 'src/Models/WebinarLibraryModel';
import { CheckAuth } from 'src/Services/utility.service';
import { WebinarLibraryService } from 'src/Services/webinar-library.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-webinar-library',
  templateUrl: './manage-webinar-library.component.html',
  styleUrls: ['./manage-webinar-library.component.css']
})
export class ManageWebinarLibraryComponent implements OnInit {
  webinarLibraryModel = new WebinarLibraryModel();
  loginuserID: number = 0;
  productId: number = 1;
  tokenKey: string = '';
  SelectedTool: string;

  webinarLibraryId: number = 0;
  isMultipleClick: boolean = false;
  file: any;
  @ViewChild('fileUpload', { static: true }) fileUpload;
  isShowprogressSpinner = false;
  blockedDocument = false;
  @ViewChild('FreeModelButton', { static: true }) FreeModelButton: ElementRef;
  popupmsg: string = '';
  issubmitted: boolean = false;
  isEmbed: boolean = true;

  dropdownOptionSettings = {}
  dropdownOptionItems = [];
  listOfOptionSelected = [];
  isSelectExternalURL: boolean = false;
  isSelectFileUpload: boolean = false;
  isErrorOnUploadDoc: boolean = false;
  selectedFiles: File;
  selectedOptionItems = [];

  dropdownListSection = [];
  selectedItemsSections = [];
  dropdownSettingsSections = {};
  selectedSectionItems = [];

  constructor(private readonly activedRoute: ActivatedRoute, 
    private readonly router: Router, 
    private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly webinarService: WebinarLibraryService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Manage Webinar Library');
    this.loginuserID = this.sessionStorageService.getAdminUserId();

    this.dropdownOptionSettings = {
      singleSelection: true,
      text: 'Select',
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.getAllSections();


  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.FillselectoptionDropdown();
    this.webinarLibraryModel.isEmbed = this.isEmbed;
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.webinarLibraryId = params['id'];
          this.GetWebinarLibraryData();
        }
      }
      else {
        this.webinarLibraryModel.isActive = true;
      }
    });
    this.dropdownSettingsSections = {
      singleSelection: true,
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };

  }

  GetWebinarLibraryData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.webinarService.i360WebinarLibraryFindbywebinarLibraryId(this.tokenKey, this.webinarLibraryId).subscribe(
      data => {
        if (data != null) {
          this.webinarLibraryModel = data["carrierData"];

          if (this.webinarLibraryModel.linktype != 0) {
            this.selectedOptionItems = this.dropdownOptionItems.filter(x => x.id == this.webinarLibraryModel.linktype);
            this.listOfOptionSelected.push(this.webinarLibraryModel.linktype);
            if (this.webinarLibraryModel.linktype == 1) {
              document.getElementById('inputfile').style.display = 'none'
              document.getElementById('inputUrl').style.display = 'block'
            }
            else {
              document.getElementById('inputfile').style.display = 'block'
              document.getElementById('inputUrl').style.display = 'none'
            }
          }
          if(this.webinarLibraryModel.sectionId!=null && this.webinarLibraryModel.sectionId!=0)
          {
            if(this.dropdownListSection!=null && this.dropdownListSection.length>0)
            {
              this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.webinarLibraryModel.sectionId); 
            }
            else{
            setTimeout(() => {
          this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.webinarLibraryModel.sectionId); 
        }, 800);
      }
          }
        }
      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }


  saveWebinarLibrary(webinarForm) {
    this.issubmitted = true;

    if (this.listOfOptionSelected.length == 0) {
      //this.showMessage('Please Link Type', 'Link Type Required', 'error');
      return;
    }

    if (this.listOfOptionSelected[0] == 2) {
      if (this.fileUpload.nativeElement.files.length == 0 && !this.webinarLibraryModel.displayDocName) {
        this.showMessage('Please select file', 'File Required', 'error');
        return;
      }
    }else{
    if (webinarForm.form.invalid) {
      return false;
    }
  }

    event.preventDefault();

    if (this.webinarLibraryModel.title == '' || typeof (this.webinarLibraryModel.title) == 'undefined' || this.webinarLibraryModel.title == null) {
      this.showMessage('Please enter title', 'Title Required', 'error');
      return;
    }
    if (this.selectedItemsSections == null || this.selectedItemsSections.length == 0){
      this.showMessage('Please enter Section', 'Section Required', 'error');
      return;
      }
      

    if (this.webinarLibraryModel.sortOrder == '' || typeof (this.webinarLibraryModel.sortOrder) == 'undefined' || this.webinarLibraryModel.sortOrder == null) {
      if(this.webinarLibraryModel.sortOrder!=0)
      {
        return;
      }
      //this.showMessage('Please enter sortOrder', 'SortOrder Required', 'error');
    }


    this.webinarLibraryModel.createdBy = this.loginuserID;
    this.webinarLibraryModel.modifiedBy = this.loginuserID;
    let formData = new FormData();
    formData.append('webinarLibraryId', this.webinarLibraryModel.webinarLibraryId);
    formData.append('title', this.webinarLibraryModel.title);
    if(this.webinarLibraryModel.externalURL!=null && this.webinarLibraryModel.externalURL!='null')
    {
      formData.append('externalURL', this.webinarLibraryModel.externalURL);
    }
    formData.append('displayDocName', this.webinarLibraryModel.displayDocName);
    formData.append('docPath', this.webinarLibraryModel.docPath);
    formData.append('fileUpload', this.fileUpload.nativeElement.files[0]);
    formData.append('createdBy', this.webinarLibraryModel.createdBy);
    formData.append('modifiedBy', this.webinarLibraryModel.modifiedBy);
    formData.append('isActive', this.webinarLibraryModel.isActive);
    formData.append('isAllowallAccess', this.webinarLibraryModel.isAllowallAccess);
    formData.append('isEmbed', this.webinarLibraryModel.isEmbed);
    formData.append('linktype', this.listOfOptionSelected[0]);
    formData.append('sortOrder', this.webinarLibraryModel.sortOrder);
    formData.append('sectionId', this.selectedItemsSections[0].id);


    if (this.isMultipleClick) {
      return;
    }
    this.isMultipleClick = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.webinarService.i360WebinarLibraryAddUpdate(this.tokenKey, formData).subscribe(
      data => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.isMultipleClick = false;
        if (data['webinarLibraryId'] != 0) {
          if (data['webinarLibraryId'] == -1) {
            this.showMessage('Duplicate record found.', 'Duplicate', 'error');
          }
          else {
            if (this.webinarLibraryId == 0)
              this.showMessage('Record saved successfully', 'Save', 'success');
            else
              this.showMessage('Record updated successfully', 'Update', 'success');
            this.webinarLibraryId = 0;
            this.cancelWebinarLibrary()
          }
        }
      },
      error => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.isMultipleClick = false;
        this.issubmitted = false;
        console.log(error)
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  cancelWebinarLibrary() {
    this.router.navigate(['admin/jsi360/WebinarLibrary']);
  }

  IfFreeProduct(event) {
    if (this.webinarLibraryId > 0) {
      this.FreeModelButton.nativeElement.click();
      this.popupmsg = event ? 'Are you sure you want to allow access to this item to all companies and subscribers having access to Webinar Library?' : 'Are you sure you want to remove access to this item from all companies and subscribers having access to this Webinar Library?';
    }
  }

  Cancelpopup() {
    this.GetWebinarLibraryData();
  }


  FillselectoptionDropdown() {
    this.dropdownOptionItems.push({ "id": '1', "itemName": "External URL" });
    this.dropdownOptionItems.push({ "id": '2', "itemName": "File Upload" });
  }

  onSelectOption($event) {
    this.listOfOptionSelected = [];
    this.listOfOptionSelected.push($event.id);
    if ($event.id == 1) {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'block'
    } else if ($event.id == 2) {
      document.getElementById('inputfile').style.display = 'block'
      document.getElementById('inputUrl').style.display = 'none'
    } else {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'none'
    }
  }

  onDeselectOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  onDeselectAllOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  fileEvent(event): any {
    var file = event.target.files[0];
    let size = Math.round(file.size / 1024);
    if (size <= 21000) {
      var allowedExtensions = ["doc", "DOC", "docx", "DOCX", "pdf", "PDF"];
      let fileType = file.name.split('.').pop();

      if (!this.isInArray(allowedExtensions, fileType)) {
        this.showMessage('You have selected an invalid file type.System supports following file formats: PDF, DOC, DOCX.', 'Error', 'error');
        this.isErrorOnUploadDoc = true;
        window.scrollTo(0, 0);
      }
      else {
        this.isErrorOnUploadDoc = false;
        this.selectedFiles = event.target.files;
      }
    }
    else {
      this.showMessage('You have selected a larger file. supports file upto 20MB.', 'Error', 'error');
      this.isErrorOnUploadDoc = true;
      window.scrollTo(0, 0);
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  getAllSections() {
    this.webinarService.i360WebinarSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
      }
    });
  }
  onSelectedSection($event) {
    // this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
    // this.selectedItemsSections.push($event.id);
  }

  onDeSelectedSection($event) {
    if (this.selectedItemsSections != null) {
      if (this.selectedItemsSections.length > 0) {
        this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
      }
    }
  }

}
